export default {"src":"/_next/static/media/roadmap1.ad77315d.svg","height":34,"width":34};